import * as React from 'react';

import { PageTitleBar } from 'components';

const BrandHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { BrandHeader };
